import { useMutation, useQueryClient } from "@tanstack/react-query";
import get from "lodash/get";
import { useToast } from "@/components/ui/use-toast";
import api, { ALERTS_KEY, ALERTS_REST_ENDPOINT } from "@/api/api";

type UseAlertsBatchDeleteMutationParams = {
  ids: string[];
};

const useAlertsBatchDeleteMutation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ ids }: UseAlertsBatchDeleteMutationParams) => {
      const { data } = await api.post(`${ALERTS_REST_ENDPOINT}delete`, {
        ids: ids,
      });
      return data;
    },
    onError: (error) => {
      const message = get(
        error,
        ["response", "data", "message"],
        error.message,
      );

      toast({
        title: "Error",
        description: message,
        variant: "destructive",
      });
    },
    onSettled: () => {
      return queryClient.invalidateQueries({
        queryKey: [ALERTS_KEY],
      });
    },
  });
};

export default useAlertsBatchDeleteMutation;
